import React, { useState } from 'react'
import {
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
  Form,
  FormLabel,
  FormControl
} from '../../components/ui/form'
import { Card } from '../../components/ui/card'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { forgotPasswordSchema } from './validators'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { ClipLoader } from 'react-spinners'
import img from '../../pics/landImg.jpeg'
import { useToast } from '../../components/ui/use-toast'
import { useForgotPassword } from '../../migration-api/api-hooks/auth'
import { useNavigate } from 'react-router-dom'

const ForgotPassword = () => {
  const { toast } = useToast()
  const navigate = useNavigate();

  const { forgotPassword, isLoading } = useForgotPassword({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: 'Success',
        description: `${'A reset link has been sent to your email'}`
      })
	  navigate('/reset-password')
    },
    onError: error => {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: `${
          error?.response?.data?.message || 'An error occured, please try again'
        }`
      })
    }
  })

  const form = useForm({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: '',
    }
  })

  function onSubmit (values) {
    forgotPassword(values)
  }

  return (
    <section className='w-full h-full'>
      <div className=' pl-24  pt-10'>
        <img src='/sproxillogo.png' alt='' className='w-[120px]' />
      </div>
      <div className='flex flex-col'>
        <div className='w-full h-[80vh] flex flex-col gap-[10px] justify-center items-center'>
          <Card className=' h-[fit-content] w-[350px] p-[20px] min-w-[230px]'>
            <h1 className='font-extrabold text-xl'>Forgot Your Password? </h1>
            <h4 className=' text-xs'>
              No worries, we will send you a link to reset it
            </h4>
            <br />
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(onSubmit)}
                className='space-y-8'
              >
                <FormField
                  control={form.control}
                  name='email'
                  render={({ field, onChange }) => (
                    <FormItem>
                      <FormLabel>Email</FormLabel>
                      <FormControl>
                        <Input placeholder='johndoe@gmail.com' {...field}  />
                      </FormControl>
                      <FormDescription>
                        This is your registered email.
                      </FormDescription>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <Button type='submit' variant='' disabled={isLoading}>
                  {isLoading ? (
                    <span className='mx-[20px]'>
                      <ClipLoader color='primary' size={20} />
                    </span>
                  ) : (
                    <span> Reset</span>
                  )}
                </Button>
              </form>
            </Form>
          </Card>
          <div className=' text-primary text-[9px]'>
            Copyright &copy; {new Date().getFullYear()}
          </div>
        </div>
        <div className='h-[5vh] flex items-end w-full justify-center'>
          <img src={img} alt='' className=' md:w-[65%] ' />
        </div>
      </div>
    </section>
  )
}

export default ForgotPassword
